import { Button } from '../../../ui';

const Hero = () => {
  const handleScroll = () => {
    const section = document.getElementById('black-offer');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-white py-[48px]">
      <div className="container">
        <div className="flex flex-col md:gap-[57px] relative">
          <div className="flex md:flex-row md:gap-[28px] gap-[48px] flex-col-reverse">
            <div className="flex flex-col md:gap-[31px] gap-[24px] justify-center max-w-[506px] w-full md:pb-0 pb-[16px]">
              <h1 className="font-[700] md:text-[48px] text-[36px]  md:leading-[59px] leading-[44px] text-[#000000] uppercase">
                World Cup 2026 
                <br />
                <span className="uppercase">հատուկ առաջարկ</span>
              </h1>
              <div className="flex md:w-[210px] w-full items-center justify-center">
                <Button variant="blackOffer" className="md:w-[220px] w-full hover:md:w-[210px]" onClick={handleScroll}>
                  Ստանալ առաջարկ
                </Button>
              </div>
            </div>
            <div className="border w-full md:h-[393px] h-[356px] overflow-hidden rounded-[100px_0px_100px_0px]">
              <img src="/images/offers/hero-desc.png" alt="Hero Image" className="object-cover w-full h-full" />
            </div>
          </div>
          <img
            src="/images/offers/color-bool.png"
            alt="bool"
            className="w-[96px] h-[109px] right-0 top-[45%] absolute z-30 transform block md:hidden "
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
